import { useSearchParams } from "react-router-dom";
import FluxiLogo from "../assets/svg/FluxiLogo.svg";
import metaLogo from "../assets/images/meta-logo.png";
import { CheckCircle2, XCircle, Link2 } from "lucide-react";

const MetaCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const isSuccess = status === "connected";

  return (
    <div className="min-h-screen bg-[#F5F6FA] flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        {/* Logos */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <img src={FluxiLogo} alt="Fluxi" className="h-8" />
          <Link2 className={`w-6 h-6 ${isSuccess ? "text-green-500" : "text-red-400"}`} />
          <img src={metaLogo} alt="Meta" className="h-8 object-contain" />
        </div>

        {/* Status icon */}
        <div className="flex justify-center mb-4">
          {isSuccess ? (
            <CheckCircle2 className="w-16 h-16 text-green-500" />
          ) : (
            <XCircle className="w-16 h-16 text-red-400" />
          )}
        </div>

        {/* Message */}
        {isSuccess ? (
          <>
            <h1 className="text-xl font-bold text-gray-800 mb-2">
              Cuenta conectada exitosamente
            </h1>
            <p className="text-sm text-gray-500 mb-8">
              Tu cuenta de Meta Ads ha sido conectada a Fluxi. Puedes cerrar esta ventana y continuar en la aplicación.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-bold text-gray-800 mb-2">
              Error al conectar
            </h1>
            <p className="text-sm text-gray-500 mb-8">
              No se pudo conectar tu cuenta de Meta Ads. Por favor cierra esta ventana e intenta nuevamente.
            </p>
          </>
        )}

        {/* Close button */}
        <button
          className={`w-full px-6 py-3 rounded-lg font-semibold text-white transition-colors ${
            isSuccess
              ? "bg-[#0081FB] hover:bg-[#006AD4]"
              : "bg-gray-600 hover:bg-gray-700"
          }`}
          onClick={() => window.close()}
        >
          Cerrar ventana
        </button>
      </div>
    </div>
  );
};

export default MetaCallbackPage;
